// extracted by mini-css-extract-plugin
export default {"LandscapeMessage":"LandscapeMessage_LandscapeMessage__BqDuu","Message":"LandscapeMessage_Message__mAB9j"};